import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getClientCredentials } from '@app/utils/auth-utils';
import * as AuthActions from './auth.actions';
import { AuthToken } from '@app/interfaces/auth';

@Injectable()
export class AuthEffects {
  
  constructor(
    private actions$: Actions,
    private http: HttpClient
  ) {}

  loadToken$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.loadToken),
      switchMap(() => {
        const url = environment.URl_MULESOFT_ORQUESTADOR_AUTH;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        
        // Usar las credenciales ensambladas de forma segura
        const credentials = getClientCredentials();
        
        const body = new HttpParams()
          .set('client_id', credentials.client_id)
          .set('grant_type', credentials.grant_type)
          .set('scope', credentials.scope)
          .set('client_secret', credentials.client_secret);

      
        return this.http.post<any>(url, body.toString(), { headers }).pipe(
          map((response) => {
            console.log('Respuesta de autenticación recibida - Estado: ÉXITO')
            if (response && response.access_token) {
              const token: AuthToken = {
                access_token: response.access_token,
                token_type: response.token_type,
                expires_in: response.expires_in,
                ext_expires_in: response.ext_expires_in,
                obtained_at: Date.now()
              };
              return AuthActions.loadTokenSuccess({ token });
            } else {
              return AuthActions.loadTokenFailure({ error: 'Failed to obtain bearer token' });
            }
          }),
          catchError((error) => {
            console.error('Error fetching bearer token:', error);
            return of(AuthActions.loadTokenFailure({ error: error.message || 'Unknown error' }));
          })
        );
      })
    )
  );
}